import React, { useState } from "react";

import IconCheckbox from "../IconCheckbox";
import StorySheet from "./StorySheet";
import { requestJson } from "./storiesHelpers";

const EMPTY_FORM = { is_public: false, name: "", source_name: "", source_url: "", text: "" };

export default function NewClozeTextSheet({ userClozeTextsUrl, onClose }) {
  const [form, setForm] = useState(EMPTY_FORM);
  const [error, setError] = useState(null);
  const [isCreating, setIsCreating] = useState(false);

  const changeField = (field, value) => setForm((previous) => ({ ...previous, [field]: value }));

  const create = async () => {
    setIsCreating(true);
    setError(null);
    try {
      const response = await requestJson({ data: form, method: "post", url: userClozeTextsUrl });
      if (response.errors) {
        setError(response.errors);
        setIsCreating(false);
        return;
      }
      window.location.href = response.path;
    } catch {
      setError("Something went wrong. Please try again.");
      setIsCreating(false);
    }
  };

  return (
    <StorySheet
      footer={
        <button
          className="btn btn-success btn-lg joystix story-sheet-primary"
          data-testid="new-cloze-text-create"
          disabled={isCreating || !form.name.trim() || !form.text.trim()}
          type="button"
          onClick={create}
        >
          Create
        </button>
      }
      testId="new-cloze-text-sheet"
      title="New cloze-text"
      onClose={onClose}
    >
      <p className="text-muted">Paste any text and we'll turn it into a story with blanks to fill in. It takes a few minutes depending on the size of the text.</p>
      {!!error && <p className="text-danger" data-testid="new-cloze-text-error">{error}</p>}
      <label className="story-setting">
        <span className="story-setting-title">Name</span>
        <input className="form-control story-setting-select" data-testid="new-cloze-text-name" value={form.name} onChange={(event) => changeField("name", event.target.value)} />
      </label>
      <label className="story-setting">
        <span className="story-setting-title">Text</span>
        <textarea
          className="form-control"
          data-testid="new-cloze-text-text"
          placeholder="Plain text, up to 20,000 characters"
          rows={8}
          value={form.text}
          onChange={(event) => changeField("text", event.target.value)}
        />
      </label>
      <label className="story-setting">
        <span className="story-setting-title">Source (optional)</span>
        <input className="form-control story-setting-select" placeholder="Project Gutenberg, a blog, etc." value={form.source_name} onChange={(event) => changeField("source_name", event.target.value)} />
      </label>
      <label className="story-setting">
        <span className="story-setting-title">Source URL (optional)</span>
        <input className="form-control story-setting-select" value={form.source_url} onChange={(event) => changeField("source_url", event.target.value)} />
      </label>
      <IconCheckbox checked={form.is_public} className="new-cloze-text-public" onChange={() => changeField("is_public", !form.is_public)}>
        <span>Public: only turn this on if you own the text or it's in the public domain.</span>
      </IconCheckbox>
    </StorySheet>
  );
}
